import React, { useEffect } from 'react';
import s from './s.module.less';
import { Input, InputNumber, InputRef } from 'antd';

type Props = React.ComponentProps<typeof Input> & {
    value?: string,
    onChange?: (val: string) => void,
    wrapClass?: string,
};

const BirthdayInput = (props: Props) => {
    const { value, onChange, ...others } = props;
    const [val, setVal] = React.useState('');

    React.useEffect(() => {
        if (value) {
            setVal(value);
        }
    }, [value]);

    return (
        <div className={s.wrap}>
            <Input
                {...others}
                onChange={(e) => {
                    const eVal = e.target.value;
                    let needAddSla = false;
                    //only allow numbers
                    let newVal = eVal.replace(/\D/g, '');
                    if (newVal.length > 4) {
                        //MM/DD/YYYY format
                        newVal = `${newVal.slice(0, 2)}/${newVal.slice(2, 4)}/${newVal.slice(4)}`;
                    } else if (newVal.length > 2) {
                        //MM/DD format
                        newVal = `${newVal.slice(0, 2)}/${newVal.slice(2)}`;
                    }
                    if (eVal.length === 3 && eVal.endsWith('/')) {
                        needAddSla = true;
                    }
                    if (eVal.length === 6 && eVal.endsWith('/')) {
                        needAddSla = true;
                    }
                    if (needAddSla) {
                        newVal += '/';
                    }
                    setVal(newVal);
                    onChange?.(newVal);
                }}
                className={`${s.input} ${others.className}`}
                //MM/DD/YYYY format
                maxLength={10}
                value={val}
                placeholder="MM/DD/YYYY"
            />
        </div>
    );
};

export default BirthdayInput;
